namespace SorAraBul.Definitions {
    export interface RestrictionsRow {
        Id?: number;
        Name?: string;
        PropertyType?: PropertyTypes;
        InsertDate?: string;
        InsertUserId?: number;
        UpdateDate?: string;
        UpdateUserId?: number;
        IsActive?: number;
    }

    export namespace RestrictionsRow {
        export const idProperty = 'Id';
        export const isActiveProperty = 'IsActive';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Definitions.Restrictions';
        export const lookupKey = 'Definitions.Restrictions';

        export function getLookup(): Q.Lookup<RestrictionsRow> {
            return Q.getLookup<RestrictionsRow>('Definitions.Restrictions');
        }
        export const deletePermission = 'Administration:SuperAdmin';
        export const insertPermission = 'Administration:SuperAdmin';
        export const readPermission = 'Administration:SuperAdmin';
        export const updatePermission = 'Administration:SuperAdmin';

        export declare const enum Fields {
            Id = "Id",
            Name = "Name",
            PropertyType = "PropertyType",
            InsertDate = "InsertDate",
            InsertUserId = "InsertUserId",
            UpdateDate = "UpdateDate",
            UpdateUserId = "UpdateUserId",
            IsActive = "IsActive"
        }
    }
}
